/* OVÉE 2026 — Design Enhancement Scripts */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     CUSTOM CURSOR + OAT GRAIN TRAIL
  ---------------------------------------------------------- */
  function initCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(forced-colors: active)').matches) return;

    var cursor = document.querySelector('.ovee-cursor');
    if (!cursor) return;

    document.documentElement.classList.add('ovee-cursor-active');

    /* Hidden until the mouse first moves — otherwise the leaf sits mid-screen on load */
    cursor.classList.add('cursor--hidden');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* --- Oat grain particle pool --- */
    var POOL   = 10;
    var DIST   = 45;  /* min px travelled before next spawn */
    var COLORS = ['#ffba3b', '#05224d', '#ffa786', 'rgba(254,246,239,0.55)'];

    /* Oat grain SVG — natural 20:42 viewBox, no forced height */
    var SVG = '<svg viewBox="0 0 20 42" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" style="width:100%;height:auto;display:block;" aria-hidden="true">'
      + '<line x1="10" y1="4" x2="10" y2="40" stroke="currentColor" stroke-width="0.9" fill="none" stroke-linecap="round"/>'
      + '<ellipse cx="6"  cy="9"  rx="2.8" ry="5.5" transform="rotate(-40 6 9)"  fill="currentColor"/>'
      + '<ellipse cx="14" cy="14" rx="2.8" ry="5.5" transform="rotate(40 14 14)" fill="currentColor"/>'
      + '<ellipse cx="6"  cy="20" rx="2.5" ry="5"   transform="rotate(-35 6 20)" fill="currentColor"/>'
      + '<ellipse cx="14" cy="25" rx="2.5" ry="5"   transform="rotate(35 14 25)" fill="currentColor"/>'
      + '<ellipse cx="6"  cy="30" rx="2.2" ry="4.5" transform="rotate(-30 6 30)" fill="currentColor"/>'
      + '<ellipse cx="14" cy="34" rx="2.2" ry="4.5" transform="rotate(30 14 34)" fill="currentColor"/>'
      + '</svg>';

    /* Use real brand PNGs if set via Theme Editor, otherwise fall back to inline SVG */
    var SRCS = (window.oveeGrains && window.oveeGrains.length) ? window.oveeGrains : null;

    var pool = [];
    var poolIdx = 0;
    var lastX = -999, lastY = -999;

    for (var p = 0; p < POOL; p++) {
      var g = document.createElement('div');
      g.setAttribute('aria-hidden', 'true');
      g.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:99997;opacity:0;';
      if (SRCS) {
        var img = document.createElement('img');
        img.src = SRCS[p % SRCS.length];
        img.style.cssText = 'width:100%;height:auto;display:block;';
        img.setAttribute('aria-hidden', 'true');
        g.appendChild(img);
      } else {
        g.innerHTML = SVG;
      }
      document.body.appendChild(g);
      pool.push(g);
    }

    function spawnGrain(x, y) {
      var el    = pool[poolIdx % POOL];
      poolIdx++;

      var w     = 40 + Math.random() * 40;          /* 40–80px wide */
      var rot   = Math.random() * 360;
      var color = SRCS ? null : COLORS[Math.floor(Math.random() * COLORS.length)];
      var ox    = (Math.random() - 0.5) * 70;
      var oy    = Math.random() * 30;           /* always at or below cursor */
      var drift = 30 + Math.random() * 50;
      var spin  = (Math.random() > 0.5 ? 1 : -1) * (40 + Math.random() * 140);

      /* Set start state (no transition) */
      el.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:99997;'
        + 'will-change:transform,opacity;'
        + 'width:' + w + 'px;'
        + (color ? 'color:' + color + ';' : '')
        + 'transform:translate(' + (x + ox - w / 2) + 'px,' + (y + oy) + 'px) rotate(' + rot + 'deg);'
        + 'opacity:0.92;transition:none;';

      /* Double-RAF → trigger CSS transition to end state */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.style.transition = 'opacity 2.4s ease, transform 2.4s ease';
          el.style.opacity    = '0';
          el.style.transform  = 'translate(' + (x + ox - w / 2) + 'px,' + (y + oy + drift) + 'px) rotate(' + (rot + spin) + 'deg)';
        });
      });
    }

    /* --- Background colour detection → brand cursor colour --- */
    var lastColorCheck = 0;

    function updateCursorColor(x, y) {
      var now = Date.now();
      if (now - lastColorCheck < 120) return;
      lastColorCheck = now;

      /* Sample under the leaf's body (it hangs down-left of the tip), not the tip itself */
      var el = document.elementFromPoint(x - 14, y + 11) || document.elementFromPoint(x, y);
      while (el && el !== document.documentElement) {
        var bg = window.getComputedStyle(el).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
          var ch = bg.match(/\d+/g);
          if (ch) {
            var lum = 0.299 * +ch[0] + 0.587 * +ch[1] + 0.114 * +ch[2];
            cursor.classList.toggle('cursor--on-dark', lum < 128);
          }
          return;
        }
        el = el.parentElement;
      }
    }

    /* --- Lerped cursor (the leaf's tip is the pointer position) --- */
    var FOLLOW = 0.38;   /* share of the gap closed per frame — high enough that the tip never visibly lags a click */
    var mouseX = 0, mouseY = 0;
    var curX = 0, curY = 0;
    var placed = false;  /* false until the first move, and again after the pointer leaves the window */
    var rafId = 0;

    function render() {
      cursor.style.transform = 'translate(calc(' + curX + 'px - var(--ovee-tip-x)), calc(' + curY + 'px - var(--ovee-tip-y)))';
    }

    /* Only runs while the leaf is catching up — no idle per-frame work */
    function tick() {
      rafId = 0;
      var dx = mouseX - curX, dy = mouseY - curY;
      if (reduceMotion.matches || dx * dx + dy * dy < 0.04) {
        curX = mouseX;
        curY = mouseY;
        render();
        return;
      }
      curX += dx * FOLLOW;
      curY += dy * FOLLOW;
      render();
      rafId = requestAnimationFrame(tick);
    }

    function follow() {
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    /* Over a text field or iframe the native cursor is more useful, so the leaf steps aside */
    var nativeSel = 'input:is([type="text"], [type="email"], [type="search"], [type="tel"], [type="url"], [type="password"], [type="number"], :not([type])), textarea, [contenteditable="true"], iframe';
    var hoverSel  = 'a, button, [role="button"], [role="tab"], summary, label, select, input, .card-wrapper, .thumbnail, .product__media-toggle, .deferred-media__poster, .modal-video__toggle, .ovee-ingredient-story__pip, .ovee-bento__stat-inner, .ovee-btn';

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;

      if (!placed) {   /* appear at the pointer instead of gliding in from wherever it was last */
        placed = true;
        curX = mouseX;
        curY = mouseY;
        render();
      }

      cursor.classList.remove('cursor--hidden');
      updateCursorColor(e.clientX, e.clientY);

      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      if (!reduceMotion.matches && !cursor.classList.contains('cursor--native') && dx * dx + dy * dy > DIST * DIST) {
        spawnGrain(e.clientX, e.clientY);
        lastX = e.clientX;
        lastY = e.clientY;
      }

      follow();
    });

    document.addEventListener('mouseleave', function () {
      cursor.classList.add('cursor--hidden');
      placed = false;
    });

    document.addEventListener('mousedown', function () {
      /* Snap to the real pointer so the tip is exactly on the click point */
      curX = mouseX;
      curY = mouseY;
      render();
      cursor.classList.add('cursor--click');
    });

    function release() { cursor.classList.remove('cursor--click'); }
    document.addEventListener('mouseup', release);
    document.addEventListener('dragend', release);
    window.addEventListener('blur', release);

    /* Recomputed on every mouseover, so it can never get stuck if an element vanishes under the pointer */
    document.addEventListener('mouseover', function (e) {
      var native = !!e.target.closest(nativeSel);
      cursor.classList.toggle('cursor--native', native);
      cursor.classList.toggle('cursor--hover', !native && !!e.target.closest(hoverSel));
    });
  }

  /* ----------------------------------------------------------
     INGREDIENT STORY — SLIDING TRACK CAROUSEL
  ---------------------------------------------------------- */
  function initIngredientStory() {
    var inner = document.querySelector('.ovee-ingredient-story__inner');
    if (!inner) return;

    var track  = inner.querySelector('.ovee-ingredient-story__track');
    var pips   = Array.from(inner.querySelectorAll('.ovee-ingredient-story__pip'));
    if (!track || !pips.length) return;

    var count   = pips.length;
    var current = 0;
    var timer;

    function goTo(index) {
      current = ((index % count) + count) % count;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      pips.forEach(function (pip, i) {
        pip.classList.toggle('is-active', i === current);
      });
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 5000);
    }

    pips.forEach(function (pip, i) {
      pip.addEventListener('click', function () {
        goTo(i);
        startTimer();
      });
    });

    // Touch swipe
    var touchStartX = 0;
    var touchStartY = 0;
    inner.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    inner.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx < 0 ? current + 1 : current - 1);
        startTimer();
      }
    }, { passive: true });

    inner.addEventListener('mouseenter', function () { clearInterval(timer); });
    inner.addEventListener('mouseleave', startTimer);

    startTimer();
  }

  /* ----------------------------------------------------------
     SCROLL REVEAL
  ---------------------------------------------------------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.ovee-reveal');
    if (!els.length) return;

    // On mobile, reveal immediately — no jank, content visible at once
    if (window.innerWidth < 750 || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------
     STICKY BUY BAR
  ---------------------------------------------------------- */
  function initStickyBar() {
    var bar = document.getElementById('ovee-sticky-bar');
    if (!bar) return;

    /* The in-page buy box: the bar steps aside while it is fully on screen (homepage baby cream, adult range page) */
    var featuredSection = document.querySelector('.shopify-section:has([id*="baby_featured"]), #shopify-section-baby_featured, .shopify-section:has([id*="adult_featured"])');
    /* Oct 2026 hero: the bar takes over only once the hero's own Shop button has scrolled away */
    var heroCta = document.getElementById('oh-hero-cta');
    var shown = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      var shouldShow = heroCta
        ? heroCta.getBoundingClientRect().bottom < 0
        : scrollY > (window.innerWidth < 750 ? 280 : 500);

      if (featuredSection) {
        var rect = featuredSection.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          shouldShow = false;
        }
      }

      /* Baby range page: ovee-baby.js marks the body while any in-page Add to bag button is on
         screen, so the bar never sits over the button it duplicates (the rule above needs the
         whole section on screen, which never happens on a phone). */
      if (document.body.classList.contains('bh-buybox-on')) shouldShow = false;

      if (shouldShow !== shown) {
        shown = shouldShow;
        bar.classList.toggle('is-visible', shown);
        bar.toggleAttribute('inert', !shown);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ----------------------------------------------------------
     BOOT
  ---------------------------------------------------------- */
  function boot() {
    /* initCursor() retired Oct 2026 (leaf cursor removed sitewide; markup gone from theme.liquid) */
    initIngredientStory();
    initScrollReveal();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
  });

})();
